import { sortBy } from 'lodash'

import ApiHandler from '@/api/base'
import { ASSIGNEE_ENTITY_KEYS } from '@/utils/entity-keys'

class HomepageUsersApiHandler extends ApiHandler {
  /**
   * @param {Object} [options={}]
   * @param {Array<number|string>|null} [options.requiredAccountIds=null]
   * @param {string|null} [options.searchString=null]
   * @param {boolean} [options.includeCurrentUser=false]
   * @returns {Promise<any>}
   */
  async getUsersForFilter({
    requiredAccountIds = null,
    searchString = null,
    includeCurrentUser = false,
    limit = undefined
  } = {}) {
    const { data } = await this.http.post('/homepage/users', {
      requiredAccountIds,
      searchString,
      includeCurrentUser,
      limit
    })

    return data
  }

  // the response may contain more than the requested ids, so the user is matched by id
  async isUserExists(accountId) {
    const { users } = await this.getUsersForFilter({ requiredAccountIds: [accountId], limit: 0 })

    return (users ?? []).some(user => user[ASSIGNEE_ENTITY_KEYS.ACCOUNT_ID] === accountId)
  }

  // the backend may pad the response, so only the requested users are kept
  async getPinnedUsersData(requiredAccountIds = []) {
    const data = await this.getUsersForFilter({
      requiredAccountIds,
      limit: 0
    })

    const users = data.users.filter(user =>
      requiredAccountIds.includes(user[ASSIGNEE_ENTITY_KEYS.ACCOUNT_ID])
    )

    // the backend returns its own order, so the pinned order saved by the user is restored here
    return sortBy(users, user => requiredAccountIds.indexOf(user[ASSIGNEE_ENTITY_KEYS.ACCOUNT_ID]))
  }

  async getUsersByName(searchString = null) {
    return await this.getUsersForFilter({ searchString })
  }

  async getUserById(accountId) {
    const users = await this.getPinnedUsersData([accountId])

    return users.at(0)
  }
}

export default HomepageUsersApiHandler
